import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import axios from "axios";
import { useDispatch } from "react-redux";
import { financeActions } from "../../redux/slices/financeSlice";
import InputProps from "../../pages/SharedContents/InputProps";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import formatDate, { dateFormat, getFormattedDate } from "../../util/dateFormat";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  modelName,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { getEncodedValue } from "../forms/utility";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

const columns: TableColumn[] = [
  { key: "reportId", header: "Report ID" },
  // { key: "companyName", header: "Company Name" },
  { key: "totalAmount", header: "Total Amount" },
  { key: "noOfVouchers", header: "No. of Vouchers" },
  { key: "submissionDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  // { key: "rejectionReason", header: "Rejection Reason" },
  { key: "createdBy", header: "Created By" },
  { key: "status", header: "Report Status" },
];

const PhysicalEvoucherNew = () => {
  const { getUserPermission: physicalVoucherPermissions } = usePermissionGetter(
    permissionsConstants.physical_voucher_reimbursement,
    permissionsConstants.physical_voucher_reimbursement
  );
  const dispatch = useDispatch();
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantId } = selectedMerchatDetails;
  const [physicalVoucherData, setPhysicalVoucherData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [errorAPI, setErrorAPI] = useState<boolean>(false);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [filterActive, setFilterActive] = useState(false);
  const [lastKey, setLastKey] = useState<any>(null);
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const [open, setOpen] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [sending, setSending] = useState(false);
  const buttonStyles = useButtonStyles();
  const [currentRoute, setCurrentRoute] = useState<string>(
    window.location.pathname
  );
  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [selectedOption, setSelecteOption] = useState("");
  const dropdownOptions = [
    { id: filterConstants.All.toLowerCase(), label: filterConstants.All },
    { id: filterConstants.Accept, label: filterConstants.Accept },
    {
      id: filterConstants.Pending,
      label: filterConstants.Pending,
    },
    { id: filterConstants.Reject, label: filterConstants.Reject },
  ];
  const amountFromRef = useRef<HTMLInputElement>();
  const amountToRef = useRef<HTMLInputElement>();
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const entityConstants = {
    amount: "total_amount",
    submittedDate: "submitted_date",
    receivedDate: "reimbursement_date",
    createdDate: "created_date",
    status: "report_status",
    amount_from: "amount_from",
    amount_to: "amount_to",
  };
  const handleExportClose = () => {
    setOpen(false);
  };

  const handleSendExport = async () => {
    const getFilterURL = bindSearchAndFilter();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.reimbursementReport,
      hashKey.placeholderId,
      hashValue.allRecords
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const fetchData = async (urlString?: any, canMergeData?: boolean) => {
    let currentURl = `${
      process.env.REACT_APP_API_URL + APIConstants.physicalVoucher
    }`;

    if (urlString) currentURl += `?${urlString}`;
    currentURl += `&module=physical_voucher_reimbursement&feature=physical_voucher_reimbursement`;

    try {
      setLoadingAPI(true);
      if (lastKey) {
        currentURl += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      if (!physicalVoucherData.length)
        getTotalRecordsCount(APIModuleConstants.pvoucher, urlString);
      const voucherResponse = await axios.get(currentURl);
      const lastData = voucherResponse?.data?.data?.data?.lastKey;
      setLastKey(lastData ? lastData : null);
      let result;
      if (currentRoute === "/merchant/physicalVoucher") {
        result = voucherResponse?.data?.data?.data?.value;
      }
      const mappedData = result.map((item: any, index: any) => ({
        id: item.report_id ? item.report_id : "-",
        reportId: item.report_id ? `Report ID # ${item.report_id}` : "-",
        reportIdDetail: item.report_id ? item.report_id : "-",
        merchant: item.merchant_name === "" ? "-" : item.merchant_name,
        companyName: item.company_name === "" ? "-" : item.company_name,
        voucherType: item.voucher_type ? item.voucher_type : "-",
        merchantID: item.merchant_id ? item.merchant_id : "-",
        totalAmount: item.total_amount ? `S$${item.total_amount}` : "-",
        noOfVouchers: item.voucher_count ? item.voucher_count : "-",
        submissionDate: getFormattedDate(item?.createdAt,dateFormat.DMMMMYYYY),
        receivedDate:  getFormattedDate(item?.reimbursement_date,dateFormat.DMMMMYYYY),
        rejectionReason: item.rejection_reason ? item.rejection_reason : "-",
        createdBy: item.created_by ? item.created_by : "-",
        status: item.report_status ? item.report_status : "-",
        navigateTo: `${"/p-voucherDetails/"}${item.report_id}`,
      }));
      const dataTOSet = canMergeData
        ? [...physicalVoucherData, ...mappedData]
        : mappedData;
      setPhysicalVoucherData(dataTOSet);
      dispatch(
        financeActions.updatePhysicalList({
          physicalVoucher: dataTOSet,
        })
      );
      setErrorAPI(false);
      setLoadingAPI(false);
    } catch (error) {
      setErrorAPI(true);
    } finally {
      setLoadingAPI(false);
      setOpen(false);
      setIsInitialApiCall(false);
    }
  };
  const onInputChange = (filedName: string, value: any, states: any) => {
    setupdatedDateFilter((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const getDateValue = (fieldItem: any) => {
    const item = updatedDateFilter[fieldItem as keyof typeof updatedDateFilter];
    return item !== undefined ? item : "";
  };
  const getInputValue = (fieldItem: any, states: any) => {
    const item = states[fieldItem as keyof typeof states];
    return item !== undefined ? item : "";
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter]
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterAmount = () => {
    const amount_From = amountFromRef.current?.value;
    const amount_to = amountToRef.current?.value;
    let amntField = {};
    const amountValue = {
      fieldValue: entityConstants.amount,
      value: [amount_From, amount_to],
      operator: operatorConstants.between,
    };
    amntField = amount_From && amount_to ? amountValue : {};
    const amnt_data = [];
    if (Object.keys(amntField).length !== 0) amnt_data.push(amntField);
    return amnt_data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: entityConstants.status,
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterValues = () => {
    const filtertype = getNormalFilter();
    const dates = getFilterDates();
    const amount = getFilterAmount();
    const status = getFilterStatus();
    const merchant = getFilterMerchant();
    return [...filtertype, ...dates, ...amount, ...status, ...merchant];
  };

  const getNormalFilter = () => {
    let filterItems = [
      {
        fieldValue: "voucher_type",
        operator: operatorConstants.equal,
        value: "physical",
      },
    ];
    return filterItems;
  };

  const getFilterMerchant = () => {
    let filterItems = [
      {
        fieldValue: "merchant_id",
        operator: operatorConstants.equal,
        value: `${merchantId}`,
      },
    ];
    return filterItems;
  };
  const handleResetFilter = () => {
    setupdatedDateFilter({});
    setSelecteOption("");
    if (amountFromRef.current) amountFromRef.current.value = "";
    if (amountToRef.current) amountToRef.current.value = "";
    onReset()
    setFilterActive(false);
  };

  const searchInputRef = useRef<HTMLInputElement>();

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];

    const filterData = getFilterValues();
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterData,
    };
    const url = getHashURL(params);
    fetchData(url, canHaveExistingData);
    return url;
  };
  const onReset = () => {
    setPhysicalVoucherData([]);
    setLastKey(null);
    setIsInitialApiCall(true);
  };
  const handleApply = () => {
    onReset();
    setOpenFilter(false);
    const newState = getFilterValues().slice(1);
    newState && setFilterActive(true);
  };

  const handleSearch = () => {
    onReset();
  };
  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <ExportDialog
        closeDialog={setOpen}
        emailSent={emailSent}
        exportTitle="Physical Voucher Reimbursement"
        handleClose={handleExportClose}
        open={open}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        height={"20%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
        py={5}
        borderBottom={theme.border?.smallGrey}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Physical Voucher Reimbursement
        </Typography>
        <Grid display={"flex"} gap={3} alignItems={"center"}>
          {physicalVoucherPermissions("export") && (
            <CommonButton
              variant="text"
              color="secondary"
              buttonTitle="Export"
              sx={{ ...buttonStyles.textSecondary }}
              onClick={() => setOpen(true)}
              disabled={!physicalVoucherData.length}
            />
          )}

          <SearchInput
            HelpTip={SearchToolTip.MerchantVoucherReImb}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          {physicalVoucherPermissions("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}

          <Dialog
            onClose={handleCloseFilter}
            open={openFilter}
            sx={{ ml: "60vw" }}
          >
            <Grid sx={{ width: "483px", py: 4, px: 2 }}>
              <DialogTitle
                display={"flex"}
                justifyContent={"space-between"}
                borderBottom={theme.border?.smallGrey}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.primary,
                    fontSize: theme.font?.fontSize.large,
                    fontWeight: theme.font?.fontWeight.thicker,
                  }}
                >
                  Filter
                </Typography>
                <IconButton onClick={() => setOpenFilter(false)}>
                  <CloseOutlinedIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Total Amount($)
                </Typography>
                <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    placeholder="From"
                    inputRef={amountFromRef}
                  />
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    placeholder="To"
                    inputRef={amountToRef}
                  />
                </Grid>
                <InputProps
                  label="Submitted Date"
                  value={getDateValue(entityConstants.submittedDate)}
                  type="date"
                  inputPlaceHolder="From"
                  onInputChange={(event: any) =>
                    onInputChange(
                      entityConstants.submittedDate,
                      event.target.value,
                      setupdatedDateFilter
                    )
                  }
                />
                <InputProps
                  label="Received Date"
                  value={getDateValue(entityConstants.receivedDate)}
                  type="date"
                  inputPlaceHolder="From"
                  onInputChange={(event: any) =>
                    onInputChange(
                      entityConstants.receivedDate,
                      event.target.value,
                      setupdatedDateFilter
                    )
                  }
                />

                <InputProps
                  label="Report Status"
                  value={selectedOption}
                  type="Select"
                  inputPlaceHolder="From"
                  onInputChange={(event: any) => {
                    setSelecteOption(event.target.value);
                  }}
                  options={dropdownOptions}
                />
              </DialogContent>
              <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
                <Button
                  sx={{ ...buttonStyles.outlinedSecondary }}
                  onClick={handleResetFilter}
                >
                  Reset
                </Button>
                <Button
                  sx={{ ...buttonStyles.containedSecondary }}
                  onClick={handleApply}
                >
                  Apply
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      </Grid>
      <Grid p={4}>
        {physicalVoucherPermissions("read") && (
          <InfiniteTable
            header={columns}
            contentItems={physicalVoucherData}
            fetchMoreData={() => bindSearchAndFilter(true)}
            hasMoreRecords={lastKey !== null}
            isInitialLoading={physicalVoucherData.length === 0 && loadingAPI}
            totalRecords={totalCount}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default PhysicalEvoucherNew;
